import React from 'react';
import HeaderComponent from '../HeaderComponent';
import MainContactoComponent from './MainContactoComponent';
import FooterComponent from '../FooterComponent';

export default function ContactanosComponent() {
  return (
    <>
      <HeaderComponent />
      <br />
      <MainContactoComponent />
      <br />
      <FooterComponent />
    </>
  )
}
